import React, { useContext, useEffect } from "react";
import Hero from "../../Components/E-Commerces/ESPER Honey/Hero";
import Products from "../../Components/E-Commerces/ESPER Honey/Products";
import { AppContext } from "../../Contexts/AppContext";

const ESPER = () => {
  const context = useContext(AppContext);
  useEffect(() => {
    localStorage.setItem("current", "commerce");
    context.setCurrent("commerce");
  }, [context]);

  return (
    <div>
      <Hero />
      <Products />
    </div>
  );
};

export default ESPER;
